import { render, staticRenderFns } from "./RegistrationForms.vue?vue&type=template&id=35013130&"
import script from "./RegistrationForms.vue?vue&type=script&lang=ts&"
export * from "./RegistrationForms.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationForms.vue?vue&type=style&index=0&id=35013130&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports